import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetPermissionTableColumns from "./ColumnDefinition/PermissionColumn/GetPermissionTableColumns";
import { mapPermissionToDataTable as mapData } from "./Helper";

const PermissionTable = ({ data }) => {
  const columns = GetPermissionTableColumns();

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default PermissionTable;
